(function () {
  if (window.__faqAccordionReady) return;
  window.__faqAccordionReady = true;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cancelAnim(panel) {
    if (!panel) return;
    var prev = panel._faqOnEnd;
    if (prev) {
      panel.removeEventListener('transitionend', prev);
      panel._faqOnEnd = null;
    }
    panel.style.transition = '';
    panel.style.height = '';
  }

  function closeItem(item, instant) {
    item.classList.remove('is-open');
    var btn = item.querySelector('[data-faq-trigger]');
    var panel = item.querySelector('[data-faq-panel]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (!panel) return;
    cancelAnim(panel);
    if (panel.hidden) return;
    if (prefersReduced || instant) {
      panel.hidden = true;
      panel.style.height = '';
      return;
    }
    var startH = panel.getBoundingClientRect().height;
    panel.style.height = startH + 'px';
    requestAnimationFrame(function () {
      panel.style.transition = 'height 220ms ease';
      panel.style.height = '0px';
    });
    var onEnd = function (event) {
      if (event.propertyName !== 'height') return;
      panel.hidden = true;
      panel.style.height = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
      panel._faqOnEnd = null;
    };
    panel._faqOnEnd = onEnd;
    panel.addEventListener('transitionend', onEnd);
  }

  function openItem(item, instant) {
    item.classList.add('is-open');
    var btn = item.querySelector('[data-faq-trigger]');
    var panel = item.querySelector('[data-faq-panel]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (!panel) return;
    cancelAnim(panel);
    panel.hidden = false;
    var inner = panel.firstElementChild;
    if (!inner) return;
    if (prefersReduced || instant) {
      panel.style.height = '';
      return;
    }
    panel.style.height = '0px';
    requestAnimationFrame(function () {
      panel.style.transition = 'height 240ms ease';
      panel.style.height = inner.scrollHeight + 'px';
    });
    var onEnd = function (event) {
      if (event.propertyName !== 'height') return;
      panel.style.height = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', onEnd);
      panel._faqOnEnd = null;
    };
    panel._faqOnEnd = onEnd;
    panel.addEventListener('transitionend', onEnd);
  }

  function normalize(items) {
    var defaultOpen = items.find(function (item) {
      return item.hasAttribute('data-open-default');
    });

    if (defaultOpen) {
      items.forEach(function (item) {
        if (item !== defaultOpen) {
          item.classList.remove('is-open');
          var panel = item.querySelector('[data-faq-panel]');
          var btn = item.querySelector('[data-faq-trigger]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          if (panel) {
            cancelAnim(panel);
            panel.hidden = true;
          }
        }
      });
      var openPanel = defaultOpen.querySelector('[data-faq-panel]');
      var openBtn = defaultOpen.querySelector('[data-faq-trigger]');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (openPanel) {
        cancelAnim(openPanel);
        openPanel.hidden = false;
        openPanel.style.height = '';
      }
      return;
    }

    items.forEach(function (item) {
      var panel = item.querySelector('[data-faq-panel]');
      var btn = item.querySelector('[data-faq-trigger]');
      var opened = item.classList.contains('is-open');
      if (btn) btn.setAttribute('aria-expanded', opened ? 'true' : 'false');
      if (panel) {
        cancelAnim(panel);
        panel.hidden = !opened;
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.faqAccordionInitialized === 'true') return;

    var items = Array.from(root.querySelectorAll('[data-faq-item]'));
    if (!items.length) return;

    root.dataset.faqAccordionInitialized = 'true';

    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-trigger]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          if (other !== item) closeItem(other);
        });
        if (isOpen) closeItem(item);
        else openItem(item);
      });
    });

    normalize(items);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-faq]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
